import {css} from 'aphrodite';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import getProcedureReplicateNames from 'procedures/utils/getProcedureReplicateNames';
import getProcedureRunConditionNames from 'procedures/utils/getProcedureRunConditionNames';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

import FormattedTextField from '../fields/FormattedTextField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {
  getProcedureStepTaskDetailsSummaryRows,
  ProcedureMethodTaskField,
} from '../procedures/getProcedureStepTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  PROCESS_TASK_DETAILS_LABELS,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getRecipeStepTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  let methodExecutionInstance = null;
  let experimentRunTask = null;
  let procedureRun = null;
  let conditionsDisplayString = null;
  if (
    processTask.procedureStepExecutionInstance != null &&
    !isInaccessible(processTask.procedureStepExecutionInstance)
  ) {
    methodExecutionInstance = processTask.procedureStepExecutionInstance?.methodExecutionInstance;
  }
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    experimentRunTask = methodExecutionInstance?.procedureRun.processFlowchartTask;
    conditionsDisplayString = getProcedureRunConditionNames(methodExecutionInstance);
  }
  let replicateDisplayString = null;
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    procedureRun = methodExecutionInstance?.procedureRun;
    replicateDisplayString = getProcedureReplicateNames(methodExecutionInstance);
  }

  return getProcedureStepTaskDetailsSummaryRows(processTask, onUpdateTask, {
    experimentRunContent: {
      label: PROCESS_TASK_DETAILS_LABELS.RECIPE_EXPERIMENT_RUN,
      component:
        experimentRunTask != null ? (
          <BenchChip
            id={isInaccessible(experimentRunTask) ? null : experimentRunTask.id}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
            size={ChipSize.TABLE_CELL}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    unitOperationContent: {
      label: PROCESS_TASK_DETAILS_LABELS.RECIPE_UNIT_OPERATION,
      component: <ProcedureMethodTaskField processTask={processTask} />,
    },
    procedureTemplateContent: {
      label: PROCESS_TASK_DETAILS_LABELS.RECIPE_TEMPLATE,
      component:
        procedureRun != null ? (
          <ProcedurePageLinkForProcedureRun
            procedureRun={procedureRun}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    conditionsContent: {
      label: PROCESS_TASK_DETAILS_LABELS.RECIPE_CONDITIONS,
      component: conditionsDisplayString ? (
        <FormattedTextField text={conditionsDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    replicatesContent: {
      label: PROCESS_TASK_DETAILS_LABELS.RECIPE_REPLICATE,
      component: replicateDisplayString ? (
        <FormattedTextField text={replicateDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
  });
}
